import isEqual from 'lodash/isEqual';
import { useRef } from 'react';
import { useExtensionList, FORGE_MODULE_XEN_MACRO } from '@confluence/forge-ui';
import { fg } from '@confluence/feature-gating';

const DEFAULT_EXTENSION_VIEWPORT_SIZES = [];

// Hook to retrieve forge app viewport sizes for initial SSR render
export const useExtensionViewportSizes = () => {
	const { extensions, loading, error } = useExtensionList({
		moduleType: FORGE_MODULE_XEN_MACRO,
		skipQuery: !fg('confluence_preload_forge_viewport_heights'),
	});

	const prevExtensionViewportSizes = useRef(DEFAULT_EXTENSION_VIEWPORT_SIZES);

	if (loading || error || !extensions) {
		return fg('cc_complexit_fe_reduce_rerender') ? DEFAULT_EXTENSION_VIEWPORT_SIZES : [];
	}

	if (fg('cc_complexit_fe_reduce_rerender')) {
		const nextExtensionViewportSizes = extensions
			.map(({ id, properties }) =>
				properties?.viewportSize
					? { extensionId: id, viewportSize: properties.viewportSize }
					: undefined,
			)
			.filter(Boolean);

		if (
			prevExtensionViewportSizes.current.length !== nextExtensionViewportSizes.length ||
			!isEqual(prevExtensionViewportSizes.current, nextExtensionViewportSizes)
		) {
			// @ts-ignore FIXME: Find the right type during clean up.
			prevExtensionViewportSizes.current = nextExtensionViewportSizes;
		}
		return prevExtensionViewportSizes.current;
	}

	return extensions
		.map((extension) =>
			extension.properties?.viewportSize
				? { extensionId: extension.id, viewportSize: extension.properties.viewportSize }
				: {},
		)
		.filter((item) => Object.keys(item).length > 0);
};
